// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__Q3UO5","InputElement":"Input_InputElement__B1rNc"};